import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

const classes = {
	listFirstLevel: 'js-m-filter-multiselect__list-level1',
	listFirstLevelOpen: 'm-filter-multiselect__list-level1--open',
	listFirstLevelShadow: 'm-filter-multiselect__list-level1--shadow',
	itemFirstLevel: 'js-m-filter-multiselect__item--level1',
	itemFirstLevelOpen: 'm-filter-multiselect__item--level1-open',
	itemFirstLevelHeaderMobile: 's-filter-multiselect__item-link--main',
	itemFirstLevelHeaderMobileOpen: 's-filter-multiselect__item-link--main-header',
	mainItemLink: 'js-m-filter-multiselect__item-link--main',
	mainItemChecked: 'm-filter-multiselect__item-link--main-checked',
	layerSecondLevelBacklink: 'js-m-filter-multiselect__backlink',
	layerSecondLevelHeader: 'js-m-filter-multiselect__layer-header-level2',
	layerSecondLevelSubfilterOpen: 'm-filter-multiselect__layer-level2--with-sublevel',
	itemSecondLevel: 'js-m-filter-multiselect__item--level2',
	confirmButton: 'js-m-filter-multiselect__confirm-button',
	floatLabel: 'state-a-label--is-floated',
	focusLabel: 'state-a-label--is-focus',
	closeFilter: 's-filter-multiselect__item-link--main-close-icon'
}

@createModule('FilterMultiselect')
/**
 * $filter-multiselect terrific module implementation
 *
 * @author Sandy Zhao <Sandy.Zhao@delaware.pro>
 */
export class FilterMultiselect extends TerrificSpec {
	$ctx: JQuery;
	$confirmButton: JQuery;
	$itemSecondLevel: JQuery;
	$listFirstLevel: JQuery;
	$itemFirstLevel: JQuery;
	$itemFirstLevelHeaderMobile: JQuery;
	$floatLabel: JQuery;
	$closeFilter: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$confirmButton = $(`.${classes.confirmButton}`, this.$ctx);
		this.$itemSecondLevel = $(`.${classes.itemSecondLevel}`, this.$ctx);
		this.$listFirstLevel = $(`.${classes.listFirstLevel}`, this.$ctx);
		this.$itemFirstLevel = $(`.${classes.itemFirstLevel}`, this.$ctx);
		this.$itemFirstLevelHeaderMobile = $(`.${classes.itemFirstLevelHeaderMobile}`, this.$ctx);
		this.$closeFilter = $(`.${classes.closeFilter}`, this.$ctx);

		this.$floatLabel = this.$ctx.prev();
		this.$floatLabel.addClass(classes.floatLabel);

		this.$ctx.on('click', `.${classes.listFirstLevel}, .${classes.layerSecondLevelHeader}`, this.onToggleOverlayClick.bind(this));

		this.$confirmButton.on('click', this.onConfirmButtonClick.bind(this));
		this.$closeFilter.on('click', this.onCloseFilter.bind(this));

		this.$ctx.on('click', `.${classes.itemSecondLevel}`, this.onPrimaryfilterClick.bind(this));

		$('input[type=checkbox]', this.$ctx).on('click',
			(event: Event) => {
				event.preventDefault();
			});

		this.setFilterCheckedClass();

		resolve();
	}

	onToggleOverlayClick(event: Event) {
		this.toggleFilter();
        event.stopPropagation();
        event.preventDefault();
	}

	onConfirmButtonClick(event: Event) {
		this.closeFilter();
		event.stopPropagation();
		event.preventDefault();
	}

	onCloseFilter(event: Event) {
		this.closeFilter();
		this.$ctx.trigger('FilterMultiCloseButton', [event]);
		event.stopPropagation();
		event.preventDefault();
	}

	onPrimaryfilterClick(event: Event) {
		const $checkbox = $(event.currentTarget as HTMLElement).find('input[type=checkbox]');
		if ($checkbox.prop("disabled")) return false;
		this.setFilter($checkbox);
		this.$ctx.trigger('FilterMultiCheckboxChanged',[event]);
		event.stopPropagation();
		event.preventDefault();
	}

	setFilter($checkbox: JQuery) {
		$checkbox.prop('checked', !$checkbox.prop('checked'));
		this.$confirmButton.show();

		this.setFilterCheckedClass();
	}

	isAnyFilterChecked($checkboxes: JQuery = $('input[type=checkbox]', this.$ctx)) {
		return $checkboxes.toArray().some(this.isElementChecked);
	}

	isElementChecked(element: HTMLInputElement): any {
		return element.checked;
	}

	setFilterCheckedClass() {
		$(`.${classes.mainItemLink}`, this.$ctx).toggleClass(classes.mainItemChecked, this.isAnyFilterChecked());
	}

	toggleFilter(toggleState?: any) {
		this.closeAllSubFilterValues();
		this.$confirmButton.hide();
		this.$listFirstLevel
			.toggleClass(classes.listFirstLevelOpen, toggleState)
			.toggleClass(classes.listFirstLevelShadow, toggleState);

		this.$itemFirstLevel.toggleClass(classes.itemFirstLevelOpen, toggleState);
		this.$floatLabel.toggleClass(classes.focusLabel, toggleState);
		this.$itemFirstLevelHeaderMobile.toggleClass(classes.itemFirstLevelHeaderMobileOpen, toggleState);
	}

	openFilter() {
		this.toggleFilter(true);
	}

	closeFilter() {
		this.toggleFilter(false);
	}

	openFilterValueClick(event: Event) {
		const $currentTargetElement = $(event.currentTarget);

		this.$itemSecondLevel.hide();
		$currentTargetElement
			.closest(`.${classes.itemSecondLevel}`)
			.show();
	}

	closeAllSubFilterValues() {
		this.$itemSecondLevel.show();
	}

	stop() {}
}
